import script from "./DownloadCentre.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadCentre.vue?vue&type=script&setup=true&lang=js"

import "./DownloadCentre.vue?vue&type=style&index=0&id=43497986&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43497986"]])

export default __exports__